import "../../pages/styles/forms.scss";
import PropTypes from "prop-types";

const FormSelect = ({
  children,
  htmlFor,
  errorMessage,
  labelText,
  isFieldRequired
}) => {
  return (
    <div className="form-group">
      <div className="label-wrapper">
        <label htmlFor={htmlFor} className="label">
          {isFieldRequired ? `${labelText}*` : labelText}
        </label>
        {isFieldRequired && errorMessage && (
          <div className="error-msg">{errorMessage}</div>
        )}
      </div>
      {children}
    </div>
  );
};

export default FormSelect;

FormSelect.propTypes = {
  children: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  isFieldRequired: PropTypes.string.isRequired,
  htmlFor: PropTypes.string
};
